<section class="page-container">
  <div class="container-fluid" style="padding: 0">
    <div class="polo-header">
      <h1>Volkswagen
        <br>
        <span>Polo</span>
      </h1>
      <img src="../../assets/images/showroom-banners/polo.png">
    </div>
  </div>
</section>
<app-showroom></app-showroom>
